import React from 'react'
import { useLocation } from 'react-router-dom'

import {
  Paper,
  makeStyles,
  Container,
  createStyles,
  Typography,
  Theme,
  Button,
  Box,
} from '@material-ui/core'

import PATHS from '~/router/paths'
import useResetSale from '~/sale/hooks/useResetSale'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      display: 'flex',
      marginTop: theme.spacing(14),
      height: '112px',
      flexBasis: '100%',
    },
    container: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: 0,
      maxWidth: '100%',
    },
    title: {
      marginLeft: theme.spacing(6),
    },
    button: {
      marginRight: theme.spacing(6),
    },
  }),
)

export default function Title() {
  const { paper, container, title, button } = useStyles()
  const location = useLocation()
  const isCheckoutPage = location.pathname.includes(PATHS.CHECKOUT)
  const isCancellableFlowPage = isCheckoutPage || location.pathname.includes(PATHS.SALES_START)
  const { selectResetSaleModalMessage } = useResetSale()
  return (
    <Paper square className={paper} elevation={0}>
      <Container className={container}>
        <Typography variant="h2" className={title}>
          Cliente nuevo
        </Typography>
        <Box>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            className={button}
            onClick={() => selectResetSaleModalMessage('EXIT_SALE')}
          >
            Volver a +Care
          </Button>
          {isCheckoutPage && (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              className={button}
              onClick={() => selectResetSaleModalMessage('EXIT_SALE_CURRENT_CLIENT')}
            >
              Volver a +Care con este cliente
            </Button>
          )}
          {!isCancellableFlowPage ? (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              className={button}
              onClick={() => selectResetSaleModalMessage('CANCEL_SALE')}
            >
              Cancelar venta
            </Button>
          ) : null}
        </Box>
      </Container>
    </Paper>
  )
}
